import { Eye, Lock } from "lucide-react"
import type { CmsAccess } from "../permissions"

// Tells the user up front why their edits won't save, instead of only on the refused write
export function EditorAccessNotice({ access, live, staged = false }: { access: CmsAccess; live: boolean; staged?: boolean }) {
  if (access === "view") {
    return (
      <div className="flex shrink-0 items-center gap-2 border-b bg-muted/40 px-3 py-1.5 text-[11px] text-muted-foreground">
        <Eye className="h-3.5 w-3.5 shrink-0" />
        View only. Your role can't change this section.
      </div>
    )
  }
  if (access === "edit" && live) {
    return (
      <div className="flex shrink-0 items-center gap-2 border-b bg-amber-50 px-3 py-1.5 text-[11px] text-amber-900 dark:bg-amber-950/30 dark:text-amber-200">
        <Lock className="h-3.5 w-3.5 shrink-0" />
        {staged
          ? "Published. Your saved changes wait for a manager to publish them."
          : "Published. Only a manager can change live content."}
      </div>
    )
  }
  return null
}
